import React, {useCallback, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import QtCategoryName from "../../../../visComponents/qtCategoryName";
import QuotesSwitcherLists from "./quotesSwitcherLists";
import PropTypes from "prop-types";
import {clearAllMenusEvents} from "../../canvas/core/workspace/workspaceEvents";
import {getQuoteDisplayName} from "../../../../../misc/quotesFunctions";
import {ACTIVE_ROOM_TYPE} from "../../../../../reducers/sqft/sqftMenuReducer";
import FeatureName from "../../../../visComponents/featureName";
import {getRoomGroupById} from "../../../helpers/sqftQuotesHelper";

const QuotesSwitcher = (props) => {
  const {qtActiveCategory, windowWidth, activeRoomType, intl, activeQuoteIndex, quotes, cartItems, fabricatorData,
    activeRoomId} = props;
  const {type} = props;
  const [isToggled, setIsToggled] = useState(false);

  const handleWrapperBlur = useCallback((e) => {
    if (isToggled && !e.target.closest('.ui-select2__dropdown-list-item')
      && !e.target.closest('.ui-select2__dropdown-back') && !e.target.closest('.ui-select2__dropdown')) {
      setIsToggled(false);
      window.removeEventListener('click', handleWrapperBlur)
    }
  }, [setIsToggled, isToggled]);

  const handleToggleDropdown = useCallback(() => {
    setIsToggled(!isToggled)
  }, [setIsToggled, isToggled]);

  const handleDropDownClick = () => {
    handleToggleDropdown();
    window.removeEventListener('click', handleWrapperBlur);
    clearAllMenusEvents();
  };

  useEffect(() => {
    setTimeout(() => {
      isToggled
        ? window.addEventListener('click', handleWrapperBlur)
        : window.removeEventListener('click', handleWrapperBlur)
    }, 0)

    return window.removeEventListener('click', handleWrapperBlur)
  },[isToggled, handleWrapperBlur]);

  const baseClass = type === 1 ? "ui-select" : "ui-select" + type;
  const dropDownStyles = isToggled ? { height: window.innerHeight - 60 } : {};
  if (isToggled) {
    dropDownStyles.height = (windowWidth > 991 && window.innerHeight > 320) ? 320 : window.innerHeight - 60
  }

  let switcherTitle = '';
  let roomNavItem;
  switch (activeRoomType) {
    case ACTIVE_ROOM_TYPE.quote:
      switcherTitle = getQuoteDisplayName(activeQuoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
      break;
    case ACTIVE_ROOM_TYPE.category:
      switcherTitle = <QtCategoryName qtCategoryName={qtActiveCategory}/>
      break;
    case ACTIVE_ROOM_TYPE.roomGroup:
      roomNavItem = getRoomGroupById(activeRoomId);
      if (!roomNavItem) {
        switcherTitle = ""
      } else {
        switcherTitle = <FeatureName feature={roomNavItem.part}/>
      }
      break;
  }

  return (
    <div className="dropdown dropdown-rooms">
      <div className={baseClass + (isToggled ? ` ${baseClass}--opened` : "")}>
        <div className={baseClass+"__input"} onClick={handleToggleDropdown}>
        <span className={baseClass+"__input-label"}>
        </span>
          <span className={baseClass+"__input-value"}>
            { switcherTitle }
        </span>
        </div>
        <div className={baseClass+"__dropdown"} style={dropDownStyles}>
          <QuotesSwitcherLists
            baseClass = {baseClass}
            handleDropDownClick = {handleDropDownClick}/>
        </div>
      </div>
    </div>
  )
}

QuotesSwitcher.propTypes = {
  type: PropTypes.number.isRequired,
};

const mapStateToProps = (store) => ({
  activeRoomId: store.sqftMenuState.activeRoomId,
  activeRoomType: store.sqftMenuState.activeRoomType,
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  fabricatorData: store.fabricatorState,
  cartItems: store.cartState.cartItems,
  windowWidth: store.serverState.windowWidth,
  qtActiveCategory: store.qtState.qtActiveCategory,
})

const mapDispatchToProps = {

}

export default injectIntl (
  connect(mapStateToProps, mapDispatchToProps)(QuotesSwitcher)
);
